import axios from "axios";

export const variantChangeActions = () => {
    document.addEventListener('DOMContentLoaded', async () => {

        // Preorder Messageの表示
        const firstAdditionalMessageElement = document.querySelectorAll('.additional_message');
        if (firstAdditionalMessageElement) {
            const firstAdditionalMessageArray = Array.from(document.querySelectorAll('.additional_message'));

            firstAdditionalMessageArray.forEach( element => {
                let firstAdditionalMessage = element.textContent;
                if (firstAdditionalMessage) {
                    const formStyle = document.querySelector('#buy-button-section');
                    if ( formStyle ) {
                        formStyle.style.setProperty('--product-info-gap', '1rem');
                    }
                }
            })
            
        }

        // Alert Messageの表示
        const firstAlertMessageElement = document.querySelectorAll('.alert_message');
        if (firstAlertMessageElement) {
            const firstAlertMessageArray = Array.from(document.querySelectorAll('.alert_message'));

            firstAlertMessageArray.forEach(element => {
                let firstAlertMessage = element.textContent;
                if (firstAlertMessage) {
                    const formStyle = document.querySelector('#buy-button-section');
                    if ( formStyle ) {
                        formStyle.style.setProperty('--product-info-gap', '1rem');
                    }
                }
            });
        }

        // 税込み価格の表示切り替え
        const compareAtPriceElement = document.querySelector("compare-at-price");
        toggleTaxElement(compareAtPriceElement);

        // sticky-barの選択variantを変更
        const stickyBarElement = document.querySelector('product-sticky-bar');
        if ( stickyBarElement ) {
            const currentUrl = window.location.href;

            const variantOptionElement = document.querySelector('variant-option-value');
            if ( currentUrl.indexOf('?variant=') != -1 && variantOptionElement ) {
                const leftSubstring = currentUrl.substring(0, currentUrl.indexOf('?variant='));
                const queryString = `${leftSubstring}.js`;
                const productObject = await getProductJson(queryString);
                const variant_title = variantOptionElement.textContent;
                
                setVariantStickyBar(productObject, variant_title, stickyBarElement);
                
            } else if ( variantOptionElement ) {
                let leftSubstring = "";
                if ( currentUrl.substring(0, currentUrl.indexOf('?') != -1 )) {
                    leftSubstring = currentUrl.substring(0, currentUrl.indexOf('?'));
                } else {
                    leftSubstring = currentUrl;
                }
                const queryString = `${leftSubstring}.js`;
                const productObject = await getProductJson(queryString);
                const variant_title = variantOptionElement.textContent;

                setVariantStickyBar(productObject, variant_title, stickyBarElement);
                
            }
        }

        // GIFTCARDのラベル色変更
        const blockSwatchs = Array.from(document.querySelectorAll('.block-swatch'));
        const selecttedVariant = document.querySelector('variant-sku');

        if ( blockSwatchs && selecttedVariant ) {
            const selecttedVariantId = selecttedVariant.dataset.variantId;
            blockSwatchs.forEach( block => {
                const variantId = block.dataset.variantId;
                if ( selecttedVariantId == variantId ) {
                    block.classList.toggle('block-button-color-change');
                } else if ( block.classList.contains('block-button-color-change') ) {
                    block.classList.toggle('block-button-color-change');
                }
            })
        }


        document.addEventListener('variant:change', function(event) {
            
            const variant = event.detail.variant;
            const variant_id = event.detail.variant.id;

            // Preorder Messageの表示
            const preOrderMessageElement = document.querySelector(`#preOrderMessage-${variant_id}`);
            let additionalMessageElement = document.querySelectorAll('.additional_message');

            if (preOrderMessageElement) {
                const additionalMessageBlockArray = Array.from(additionalMessageElement);
                const preOrderMessage = preOrderMessageElement.textContent;
                const additionalMessageInputArray = Array.from(document.querySelectorAll('.additional_message_input'));

                if (preOrderMessage) {
                    const formStyle = document.querySelector('#buy-button-section');
                    formStyle.style.setProperty('--product-info-gap', '1rem');

                    additionalMessageBlockArray.forEach( element => {
                        element.innerHTML = preOrderMessage;
                        element.style.color = "#B5262B";
                    })
                    additionalMessageInputArray.forEach( element => {
                        element.value = preOrderMessage;
                    })
                    
                } else {
                    additionalMessageBlockArray.forEach( element => {
                        element.textContent = "";
                    })
                    additionalMessageInputArray.forEach( element => {
                        element.value = "";
                    })
                    
                }
            }

            // Alert Messageの表示
            const alertMessageElement = document.querySelector(`#alertMessage-${variant_id}`);
            let alertMessageBlockElement = document.querySelectorAll('.alert_message');
            if (alertMessageElement) {
                const alertMessageBlockArray = Array.from(alertMessageBlockElement);
                const alertMessage = alertMessageElement.textContent;
                if (alertMessage && alertMessage !== "" ) {
                    const formStyle = document.querySelector('#buy-button-section');
                    formStyle.style.setProperty('--product-info-gap', '1rem');

                    alertMessageBlockArray.forEach( element => {
                        element.innerHTML = alertMessage;
                        element.style.color = "#B5262B";
                    })
                    
                } else {
                    alertMessageBlockArray.forEach( element => {
                        element.textContent = "";
                    })
                }
            }

            // 税込み価格の表示切り替え
            const compareAtPriceElement = document.querySelector("compare-at-price");
            toggleTaxElement(compareAtPriceElement);

            // wazzup LINE再入荷ボタンのvariant切り替え
            const wazzupButton = document.getElementById('wazzupButton');
            wazzupButton.setAttribute('onclick', 'WazzUp.rearrival("' + variant_id + '")');
            if ( variant.available ) {
                wazzupButton.style.display = 'none';
            } else {
                wazzupButton.style.display = 'block';
            }

            // sticky-barの選択variantを変更
            const stickyBarElement = document.querySelector('product-sticky-bar');
            if ( stickyBarElement ) {

                const variantOptionElement = document.querySelector('variant-option-value');
                if ( variantOptionElement ) {
                    const productObject = event.detail.product;
                    const variant_title = variant.title;
                    
                    setVariantStickyBar(productObject, variant_title, stickyBarElement);
                    
                }
            }

            // GIFTCARDのラベル色変更
            const blockSwatchs = Array.from(document.querySelectorAll('.block-swatch'));
            if ( blockSwatchs ) {
                blockSwatchs.forEach( block => {
                    const label_title_element = block.querySelector('span');
                    let label_title = "";
                    if ( label_title_element ) {
                        label_title = label_title_element.textContent;
                    }
                    const variant_title = variant.title;
                    if ( label_title == variant_title ) {
                        block.classList.toggle('block-button-color-change');
                    } else if ( block.classList.contains('block-button-color-change') ) {
                        block.classList.toggle('block-button-color-change');
                    }
                })
            }

        });

        document.querySelectorAll('body .color-section .color-swatch-wrapper').forEach(function(element){
            element.addEventListener('click', function(e) {
                setTimeout(function() {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                }, 100);
            })
        });
    })
}

const toggleTaxElement = (compareAtPriceElement) => {
    if (compareAtPriceElement ) {
        const priceTextContent = compareAtPriceElement.textContent;
        const taxElement = document.querySelector('.c--price-list__tax');
        const taxElement_saleprice = document.querySelector('.c--price-list__tax_saleprice');
        if (priceTextContent.includes('¥0') || !priceTextContent.includes('¥')) {
            taxElement.style.display = "none";
            taxElement_saleprice.style.color = "#625E58";
        } else {
            taxElement.style.display = "block";
            taxElement_saleprice.style.color = "#b5262b";
        }
    }
}

const getProductJson = async (url) => {
    try {
        const response = await axios({
          headers: {
            "Content-Type": "application/json"
          },
          method: 'GET',
          url: url
        });
        return response.data;
      } catch (error) {
        throw new Error("Failed to get product JSON.");
      }
}

const setVariantStickyBar = (productObject, variant_title, stickyBarElement) => {
    const matchedItem = productObject.variants.find( variant => {
        return variant['title'] == variant_title;
    });
    const variantId = matchedItem.id;
    const variantInputElement = stickyBarElement.querySelector("input[name='id']");
    variantInputElement.setAttribute('value', variantId);

    const variant_media = stickyBarElement.querySelector('img');
    
    const image_src = matchedItem.featured_image.src;
    const new_secset = `${image_src}&width=60 60w, ${image_src}&width=120 120w, ${image_src}&width=180 180w`;
    variant_media.setAttribute('src',image_src);
    variant_media.setAttribute('srcset',new_secset);
}